import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import API from "./config/API";

function UserPaymentForm1() {
  //const location = useLocation();
  const navigate = useNavigate();

  //const booking = location.state?.booking || {};
  const location = useLocation();
  const useremailId = location.state?.emailId;
  const userBookingId = location.state?.userBookingId;
  const bedId = location.state?.bedId;
  const registerId = location.state?.registerId;

  const userBedJoiningDate = location.state?.userBedJoiningDate
    ? location.state.userBedJoiningDate.substring(0, 10)
    : "";
  const user = JSON.parse(localStorage.getItem("user"));

  //const registerId = localStorage.getItem("registerId");
  //const registerId = user?.registerId;

  // const registerId = 48;

  const [loading, setLoading] = useState(false);

  const [checkingBedStatus, setCheckingBedStatus] = useState(false);

  const [payment, setPayment] = useState({
    registerId: "",
    bedId: "",
    floorName: "",
    roomName: "",
    bedName: "",
    userName: "",
    mobileNumber: "",
    emailId: "",
    bedCost: 0,
    bedOfferCost: 0,
    dayBedCost: 0,

    monthlyRent: 0,
    perDayRent: 0,

    stayingType: "MONTH",
    duration: 1,
    userBedJoiningDate: userBedJoiningDate || "",

    advanceAmount: 0,
    amount: 0,
    totalAmount: 0,

    paymentMode: "ONLINE",
    paymentStatus: "PENDING",
  });

  useEffect(() => {
    console.log("Navigation State:", location.state);
    console.log("Email ID:", useremailId);
    console.log("Register ID:", registerId);

    if (useremailId) {
      fetchUserDetails();
    } else {
      console.error("Email ID is missing from navigation state");
    }
  }, [useremailId]);

  const fetchUserDetails = async () => {
    try {
      setLoading(true);
      console.log("fetchUserDetails called");

      const res = await axios.get(
        `${API.V2}/pgOwner/getUserDetailsforPaymentByuserRegisterId?emailId=${useremailId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (res.data.statusCode === 200) {
        const data = res.data.data;

        setPayment((prev) => ({
          ...prev,

          registerId: data.userRegisterId,

          bedId: data.userBedId,

          floorName: data.userFloorName,

          roomName: data.userRoomName,

          bedName: data.userBedName,

          bedCost: Number(data.bedCost || 0),
          bedOfferCost: Number(data.bedOfferCost || 0),
          dayBedCost: Number(data.dayBedCost || 0),

          userName: `${data.firstName} ${data.lastName}`,

          mobileNumber: data.contactNo,

          emailId: data.emailId,

          //  stayingType: data.userStayingType === "Guest" ? "DAY" : "MONTH",

          // Always default to Monthly
          stayingType: "MONTH",

          monthlyRent: Number(data.monthlyRent || 0),

          perDayRent: Number(data.perDayRent || 0),

          bedCost: data.bedCost,

          bedBookingId: data.userBookingId,

          amount:
            Number(data.bedOfferCost || 0) > 0
              ? Number(data.bedOfferCost)
              : Number(data.bedCost),

          totalAmount:
            Number(data.bedOfferCost || 0) > 0
              ? Number(data.bedOfferCost)
              : Number(data.bedCost),
        }));
      }
    } catch (error) {
      console.log(error);

      alert("Unable to fetch user details.");
    } finally {
      setLoading(false);
    }
  };

  // Load user details once
  useEffect(() => {
    if (registerId) {
      fetchUserDetails();
    }
  }, [registerId]);

  // Calculate amount whenever values change
  useEffect(() => {
    calculateTotal();
  }, [
    payment.stayingType,
    payment.duration,
    payment.advanceAmount,
    payment.bedCost,
    payment.bedOfferCost,
    payment.dayBedCost,
  ]);

  useEffect(() => {
    if (!bedId) {
      return;
    }

    let intervalId;
    let timeoutId;
    let isStopped = false;

    const checkBedStatus = async () => {
      if (isStopped) {
        return;
      }

      try {
        const response = await axios.get(
          `http://localhost:9777/userBooking/getBedStatus?bedId=${bedId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user?.jwtToken}`,
            },
          },
        );

        if (response.data.statusCode === 200) {
          const bedStatus = response.data.data?.bedStatus;

          console.log("Bed ID:", bedId, "Status:", bedStatus);

          // ---------------------------------------
          // BED BOOKED
          // ---------------------------------------
          if (bedStatus === "BOOKED") {
            console.log("Bed booked successfully.");

            isStopped = true;

            clearInterval(intervalId);
            clearTimeout(timeoutId);

            navigate("/userdashboard");

            return;
          }

          // ---------------------------------------
          // STILL HOLD
          // ---------------------------------------
          if (bedStatus === "BOOKING_HOLD") {
            console.log("Bed is still in BOOKING_HOLD");

            return;
          }

          // ---------------------------------------
          // BED AVAILABLE / HOLD EXPIRED
          // ---------------------------------------
          if (bedStatus === "AVAILABLE") {
            console.log("Booking hold expired.");

            isStopped = true;

            clearInterval(intervalId);
            clearTimeout(timeoutId);

            return;
          }
        }
      } catch (error) {
        console.error("Error checking bed status:", error);
      }
    };

    // Check immediately
    checkBedStatus();

    // Every 15 seconds
    intervalId = setInterval(checkBedStatus, 15000);

    // Maximum 10 minutes
    timeoutId = setTimeout(
      () => {
        console.log("10 minutes completed. Stopping bed status checking.");

        isStopped = true;

        clearInterval(intervalId);
      },
      10 * 60 * 1000,
    );

    return () => {
      isStopped = true;

      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [bedId, navigate]);

  const calculateTotal = () => {
    let rent = 0;

    if (payment.stayingType === "MONTH") {
      const monthlyRent =
        Number(payment.bedOfferCost) > 0
          ? Number(payment.bedOfferCost)
          : Number(payment.bedCost);

      rent = monthlyRent * Number(payment.duration || 1);
    } else {
      rent = Number(payment.dayBedCost || 0) * Number(payment.duration || 1);
    }

    setPayment((prev) => ({
      ...prev,
      amount: rent,
      totalAmount: rent,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPayment((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const checkBedStatus = async (bedId) => {
    try {
      const response = await axios.get(
        `http://localhost:9777/userBooking/getBedStatus?bedId=${bedId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      if (response.data.statusCode === 200) {
        const bedStatus = response.data.data?.bedStatus;

        console.log("Current Bed Status:", bedStatus);

        if (bedStatus === "BOOKED") {
          console.log("Bed is BOOKED. Navigating to dashboard.");

          setCheckingBedStatus(false);

          navigate("/userdashboard");
        }
      }
    } catch (error) {
      console.error("Error checking bed status:", error);
    }
  };

  const handlePayment = async () => {
    try {
      // ============================================
      // VALIDATION
      // ============================================

      if (!payment.registerId) {
        alert("User registration ID is missing.");
        return;
      }

      if (!payment.bedId) {
        alert("Bed ID is missing.");
        return;
      }

      if (!payment.paymentMode) {
        alert("Please select a payment mode.");
        return;
      }

      // ============================================
      // OFFLINE / CASH PAYMENT
      // ============================================

      if (payment.paymentMode === "CASH" || payment.paymentMode === "OFFLINE") {
        navigate("/offlineCashPaymentDetails", {
          state: {
            booking: {
              ...payment,

              registerId: Number(payment.registerId),
              bedId: Number(payment.bedId),

              userName: payment.userName,
              mobileNumber: payment.mobileNumber,
              emailId: payment.emailId,

              floorName: payment.floorName,
              roomName: payment.roomName,
              bedName: payment.bedName,

              bedCost: Number(payment.bedCost || 0),
              bedOfferCost: Number(payment.bedOfferCost || 0),
              dayBedCost: Number(payment.dayBedCost || 0),

              // MONTH or DAY
              stayingType: payment.stayingType,

              // Selected count
              duration: Number(payment.duration || 1),

              // IMPORTANT
              stayingDays: Number(payment.duration || 1),

              userBedJoiningDate: payment.userBedJoiningDate,

              advanceAmount: Number(payment.advanceAmount || 0),

              paymentMode: payment.paymentMode,
            },
          },
        });

        return;
      }
      // ============================================
      // ONLINE PAYMENT
      // ============================================

      if (payment.paymentMode === "ONLINE") {
        setLoading(true);

        const payload = {
          registerId: Number(payment.registerId),

          bedId: Number(payment.bedId),

          paymentType: payment.stayingType,

          stayingDays: Number(payment.duration),

          userBedJoiningDate: payment.userBedJoiningDate,

          amount: Number(payment.amount),

          advanceAmount: Number(payment.advanceAmount || 0),

          totalAmount: Number(payment.totalAmount),

          paymentMode: "RAZORPAY",

          paymentStatus: "CREATED",

          createdBy: user?.emailId || "",
        };

        console.log("ONLINE PAYMENT PAYLOAD:", payload);

        const res = await axios.post(`${API.V2}/payment/createOrder`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        });

        if (res.data.statusCode === 200) {
          navigate("/userPaymentProcessing1", {
            state: {
              razorpay: res.data.data,
              booking: payload,
            },
          });

          return;
        }

        if (res.data.statusCode === 401) {
          alert("Session expired. Please login again.");

          localStorage.clear();
          sessionStorage.clear();

          navigate("/");

          return;
        }

        alert(res.data.message || "Unable to process payment.");
      }
    } catch (error) {
      console.error("Payment error:", error);

      if (error.response?.status === 401) {
        alert("Session expired. Please login again.");

        localStorage.clear();
        sessionStorage.clear();

        navigate("/");

        return;
      }

      alert(error.response?.data?.message || "Unable to process payment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>User Payment Details</h2>

        {/* USER DETAILS */}

        <div style={styles.sectionTitle}>User Information</div>

        <div style={styles.grid}>
          <div>
            <label style={styles.label}>User Name</label>

            <input
              value={payment.userName}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Mobile Number</label>

            <input
              value={payment.mobileNumber}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Email</label>

            <input
              value={payment.emailId}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>
        </div>

        {/* BED DETAILS */}

        <div style={styles.sectionTitle}>Bed Information</div>

        <div style={styles.grid}>
          <div>
            <label style={styles.label}>Floor</label>

            <input
              value={payment.floorName}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Room</label>

            <input
              value={payment.roomName}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Bed</label>

            <input
              value={payment.bedName}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>
        </div>

        {/* RENT DETAILS */}

        <div style={styles.sectionTitle}>Rent Details</div>

        <div style={styles.grid}>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <label
                style={{
                  ...styles.label,
                  marginBottom: 0,
                }}
              >
                Monthly Rent
              </label>

              {payment.bedOfferCost > 0 && (
                <span
                  style={{
                    color: "#dc2626",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Actual Bed Cost :
                  <span
                    style={{
                      marginLeft: "4px",
                      textDecoration: "line-through",
                      fontWeight: "700",
                    }}
                  >
                    ₹{payment.bedCost}
                  </span>
                </span>
              )}
            </div>

            <input
              value={`₹ ${
                payment.bedOfferCost > 0
                  ? payment.bedOfferCost
                  : payment.bedCost
              }`}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
                fontWeight: "700",
                color: "#16a34a",
                fontSize: "16px",
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Per Day Rent</label>

            <input
              value={payment.dayBedCost}
              readOnly
              style={{
                ...styles.input,
                ...styles.readonly,
              }}
            />
          </div>

          <div>
            <label style={styles.label}>Stay Type</label>

            <select
              name="stayingType"
              value={payment.stayingType}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="MONTH">Monthly</option>
              <option value="DAY">Daily</option>
            </select>
          </div>

          <div>
            <label style={styles.label}>
              {payment.stayingType === "MONTH"
                ? "Number of Months"
                : "Number of Days"}
            </label>

            <select
              name="duration"
              value={payment.duration}
              onChange={handleChange}
              style={styles.input}
            >
              {[...Array(12)].map((_, index) => (
                <option key={index + 1} value={index + 1}>
                  {index + 1}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.label}>Joining Date</label>

            <input
              type="date"
              name="userBedJoiningDate"
              value={payment.userBedJoiningDate}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              max={(() => {
                const date = new Date();
                date.setDate(date.getDate() + 3);
                return date.toISOString().split("T")[0];
              })()}
              style={styles.input}
            />
          </div>
          <div>
            <label style={styles.label}>Advance Amount</label>

            <input
              type="number"
              name="advanceAmount"
              min="0"
              max={
                payment.bedOfferCost > 0
                  ? payment.bedOfferCost
                  : payment.bedCost
              }
              value={payment.advanceAmount}
              onChange={(e) => {
                const value = Number(e.target.value);

                const maxAdvance =
                  payment.bedOfferCost > 0
                    ? payment.bedOfferCost
                    : payment.bedCost;

                if (value <= maxAdvance) {
                  setPayment((prev) => ({
                    ...prev,
                    advanceAmount: value,
                  }));
                }
              }}
              style={styles.input}
            />

            <small style={{ color: "#64748b" }}>
              Maximum Advance Amount: ₹
              {payment.bedOfferCost > 0
                ? payment.bedOfferCost
                : payment.bedCost}
            </small>
          </div>

          <div>
            <label style={styles.label}>Payment Mode</label>

            <select
              name="paymentMode"
              value={payment.paymentMode}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="">Select Payment Mode</option>

              <option value="ONLINE">Online Payment</option>

              <option value="CASH">Cash to Hand</option>

              <option value="OFFLINE">Offline Payment</option>

              <option value="BANK_TRANSFER">Bank Transfer</option>

              <option value="QR_CODE">QR Code</option>
            </select>
          </div>
        </div>

        {/* PAYMENT SUMMARY */}

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>Stay Type</span>
          <span style={styles.summaryValue}>
            {payment.stayingType === "MONTH" ? "Monthly" : "Daily"}
          </span>
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>
            {payment.stayingType === "MONTH" ? "Months" : "Days"}
          </span>
          <span style={styles.summaryValue}>{payment.duration}</span>
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>
            {payment.stayingType === "MONTH" ? "Monthly Rent" : "Daily Rent"}
          </span>
          <span style={styles.summaryValue}>₹ {payment.amount}</span>
        </div>

        <div style={styles.summaryRow}>
          <span style={styles.summaryLabel}>Advance Amount</span>
          <span style={styles.summaryValue}>₹ {payment.advanceAmount}</span>
        </div>

        <div style={styles.totalRow}>
          <span>Total Amount</span>
          <span>₹ {payment.totalAmount}</span>
        </div>
        <button
          style={styles.button}
          disabled={loading}
          onClick={handlePayment}
        >
          {loading ? "Processing Payment..." : "Proceed Payment"}
        </button>
      </div>
    </div>
  );
}

export default UserPaymentForm1;
const styles = {
  page: {
    minHeight: "100vh",
    background: "#f1f5f9",
    padding: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    fontFamily: "'Segoe UI', sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "1100px",
    background: "#fff",
    borderRadius: "18px",
    padding: "35px",
    boxShadow: "0 15px 35px rgba(0,0,0,.12)",
  },

  title: {
    textAlign: "center",
    color: "#0f172a",
    fontSize: "34px",
    fontWeight: "700",
    marginBottom: "35px",
  },

  sectionTitle: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#2563eb",
    marginTop: "25px",
    marginBottom: "18px",
    borderLeft: "5px solid #2563eb",
    paddingLeft: "12px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
    gap: "22px",
    marginBottom: "25px",
  },

  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#334155",
    fontSize: "15px",
  },

  input: {
    width: "100%",
    padding: "13px 15px",
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    outline: "none",
    fontSize: "15px",
    boxSizing: "border-box",
    transition: ".3s",
  },

  readonly: {
    background: "#f8fafc",
    color: "#334155",
    fontWeight: "600",
  },

  amountBox: {
    marginTop: "30px",
    padding: "30px",
    borderRadius: "15px",
    background: "linear-gradient(135deg,#eff6ff,#dbeafe)",
    border: "2px solid #93c5fd",
    textAlign: "center",
  },

  amountTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1d4ed8",
    marginBottom: "20px",
  },

  amountValue: {
    marginTop: "20px",
    fontSize: "40px",
    color: "#16a34a",
    fontWeight: "800",
  },

  button: {
    width: "100%",
    marginTop: "35px",
    padding: "16px",
    border: "none",
    borderRadius: "12px",
    background: "linear-gradient(90deg,#2563eb,#3b82f6)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
    transition: ".3s",
    boxShadow: "0 8px 20px rgba(37,99,235,.35)",
  },

  buttonHover: {
    background: "linear-gradient(90deg,#1d4ed8,#2563eb)",
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 0",
    borderBottom: "1px dashed #cbd5e1",
    fontSize: "17px",
  },

  summaryLabel: {
    color: "#475569",
    fontWeight: "600",
  },

  summaryValue: {
    color: "#0f172a",
    fontWeight: "700",
  },

  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
    paddingTop: "20px",
    borderTop: "2px solid #2563eb",
    fontSize: "24px",
    fontWeight: "800",
    color: "#16a34a",
  },

  badge: {
    display: "inline-block",
    padding: "6px 14px",
    borderRadius: "20px",
    background: "#dcfce7",
    color: "#15803d",
    fontWeight: "700",
    fontSize: "13px",
  },

  paymentStatus: {
    display: "inline-block",
    background: "#fef3c7",
    color: "#b45309",
    padding: "8px 15px",
    borderRadius: "25px",
    fontWeight: "700",
    fontSize: "14px",
  },

  successText: {
    color: "#16a34a",
    fontWeight: "700",
  },

  dangerText: {
    color: "#dc2626",
    fontWeight: "700",
  },

  infoCard: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    padding: "18px",
    borderRadius: "12px",
    marginBottom: "20px",
  },

  infoTitle: {
    fontWeight: "700",
    color: "#1e40af",
    marginBottom: "10px",
  },

  infoText: {
    color: "#475569",
    lineHeight: "24px",
    fontSize: "15px",
  },

  divider: {
    height: "1px",
    background: "#e2e8f0",
    margin: "25px 0",
  },

  cardShadow: {
    boxShadow: "0 10px 25px rgba(0,0,0,.08)",
  },

  center: {
    textAlign: "center",
  },

  right: {
    textAlign: "right",
  },

  left: {
    textAlign: "left",
  },
};
